import styled, { createGlobalStyle } from 'styled-components'
import { media } from 'utils/styleUtils'
import { SNOW_WHITE, CHARCOAL_BLACK } from 'constants/colors'

export const GlobalStyle = createGlobalStyle`
  body {
    background: ${SNOW_WHITE};
  }
`

export const Container = styled.main`
  color: ${CHARCOAL_BLACK};
  margin-top: 52px;

  ${media.desktop} {
    /* 桌機版 Header 的高度 */
    margin-top: calc(36px + 0.8rem * 2);
  }
`

export const Intro = styled.h2`
  margin: 3rem 0 1rem;
  text-align: center;
  font-weight: normal;
`

export const Main = styled.div`
  margin: 0 auto;
  padding: 0 1rem;
  max-width: 1080px;
`
